<template>
    <div class="archive-list">
        <p class="archive-date">{{ changedDate }}</p>
        <div class="archive-detail">
            <p class="archive-title">{{ title }}</p>
            <p class="archive-a">{{ archiveA }}</p>
            <p class="archive-b">{{ archiveB }}</p>
            <p class="archive-c">{{ archiveC }}</p>
            <span v-if="isEmpty(tirasiName)">
                <a class="link-style" v-bind:href="getTirasiUrl()" target="_blank" rel="noopener noreferrer">{{ tirasiName }}</a>
            </span>
            <span v-if="isEmpty(linkName)">
                <a class="link-style"  v-bind:href="linkUrl" target="_blank" rel="noopener noreferrer">{{ linkName }}</a>
            </span>
        </div>
    </div>
</template>
<script>
import changeDateFormat from '../../util/formatter';

export default {
  props: {
    id: String,
    title: String,
    eventDate: String,
    archiveA: String,
    archiveB: String,
    archiveC: String,
    // PDFリンク
    tirasiName: String,
    // 外部サイトリンク
    linkName:String,
    linkUrl: String
    },
    data() {
        return {
            changedDate:"",
        }
    },
    created :function(){
        this.changedDate = changeDateFormat(this.eventDate);
    },
    methods: {
       getTirasiUrl:function() {
           if (this.tirasiName !== "") {
               var tirasiUrl = "https://yamadashimpei.com:9876/static/images/" + this.id + ".pdf"
               return tirasiUrl
           }
       },
        // 要素の空チェック
        isEmpty: function(content) {
            if (!content){
                return false
            }
            return true
        }
    }
  }
</script>
<style lang="scss" scoped>
.archive-list {
    display: block;
    width: 90%;
    margin: 0 auto;
    // justify-content: space-between;
    border-top: solid 1px #969696;
    padding-top: 20px;
    padding-bottom: 20px;
}
.archive-list:nth-of-type(1) {
    border-top: none;
    padding-top: 0;
}
.archive-list:last-child {
    padding-bottom: 0;
}

.archive-date {
    // width: 170px;
    margin-right: 30px;
    font-size: 14px;
}
.archive-detail {
    .archive-title {
        font-size: 16px;    
    }
    .archive-a,.archive-b,.archive-c{
        font-size: 15px;
    }
   .link-style {
    color: #969696;
    border-bottom: solid 1px #969696;
    margin-right: 14px;
    font-size: 14px;
  } 
}
// PC
@media screen and (min-width: 768px) { 
    .archive-list {
        display: flex;
        width: 100%;
    }
    .archive-date {
        // width: 15%;
        font-size: 16px;
        margin-right: 50px;
    }
    .archive-detail {
        .archive-title {
            font-size: 17px;    
        }
        .archive-a,.archive-b,.archive-c{
            font-size: 16px;
        }
    .link-style {
        color: #969696;
        border-bottom: solid 1px #969696;
        margin-right: 14px;
        font-size: 14px;
    } 
  }

}
  </style>